import React from 'react';
import { search_panel_id } from '../../extra/search-panel';

export default () => (
	<div id={ search_panel_id } style={{ display: "none" }}>
		<script type="text/x-epodroznik-module" data-module-name="ConnectionsSearcher" id="epSearcher"></script>
		<script type="text/x-epodroznik-module" data-module-name="SearchingResults" id="SearchingResults"></script>
	</div>
)